import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router";
import CustomModal from "../Modals/CustomModal";
import Loader from "../Loader/Loader";
import { message, Tooltip } from "antd";
import { getProfile } from "../../webServices/Apis";
import { SiQuickbooks } from "react-icons/si";

const Navbar = ({ toggleSidenav, onLogout, setIsAuthenticated }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState("");
  const [name, setName] = useState(localStorage.getItem("firstName"));
  const navigate = useNavigate();
  const location = useLocation();

  const handleCustomModalOpen = () => {
    setIsCustomModalOpen(true);
  };

  const cancelCustomModel = () => {
    setIsCustomModalOpen(false);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleLogOut = () => {
    const isConfirmed = window.confirm("Are you sure you want to log out?"); // Confirmation dialog with Cancel and Yes

    if (isConfirmed) {
      setLoading(true);
      try {
        localStorage.clear(); // Clear the local storage to remove user data
        setIsCustomModalOpen(false); // Close any open modals
        message.success("Successfully logged out");

        setTimeout(() => {
          window.location.href = "/login"; // Redirect to login page after logout
        }, 500);
      } catch (error) {
        console.log("Error while logging out: ", error);
        message.error("Error in log out");
      } finally {
        setLoading(false); // Stop loading spinner/indicator
      }
    } else {
      // User canceled the logout, no action needed

      setIsDropdownOpen(false);
      message.info("Logout canceled");
    }
  };

  useEffect(() => {
    setIsDropdownOpen(false);
  }, [location]);

  const handleGetProfile = async () => {
    if (!localStorage.getItem("token")) {
      return;
    }
    try {
      const response = await getProfile();

      if (response.data.success) {
        setProfileData(response?.data?.data);
        localStorage.setItem("userId", response?.data?.data?.id);
      }
    } catch (error) {
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
    }
  };

  useEffect(() => {
    setName(localStorage.getItem("firstName"));
    handleGetProfile();
  }, [name]);

  return (
    <nav className="bg-gray-800 text-white p-4 flex justify-between items-center">
      <div className="flex items-center gap-6">
        {loading && <Loader />}
        <button
          className="w-12 h-12 bg-gray-700 text-white"
          onClick={toggleSidenav}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
        <h1 className="text-xl font-bold">Axcell Painting</h1>
      </div>

      <div className="relative flex">
        {localStorage.getItem("access_token") ? (
          <div className="mr-10 flex items-center gap-3">
            <Tooltip title="This panel is connected to your Quickbooks account.">
              <SiQuickbooks className="text-4xl text-green-400" />
            </Tooltip>
            <p className="text-green-400 font-bold">Connected to Quickbooks</p>
          </div>
        ) : (
          <div className="mr-10">
            
          </div>
        )}

        <button
          onClick={handleDropdownToggle}
          className="flex items-center focus:outline-none"
        >
          <FontAwesomeIcon icon={faUser} className="text-xl" />
          <span className="ml-2"> {profileData.firstName || name}</span>
        </button>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg">
            <ul className="py-2">
              {/* <li className="px-4 py-2
      const response = await getProfile();
    
    if(response.data.success){
      setProfileData(response?.d hover:bg-gray-200 cursor-pointer" onClick={handleProfile}>
                Profile
              </li> */}
              <li
                className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                onClick={handleLogOut}
              >
                Logout
              </li>
            </ul>
          </div>
        )}
      </div>
      {/* Include Custom Modal */}
      <CustomModal
        isOpen={isCustomModalOpen}
        onClose={cancelCustomModel}
        onConfirm={handleLogOut}
        title="Confirm Logout"
        message="Are you sure you want to log out"
      />
    </nav>
  );
};

export default Navbar;
